import React from 'react';
import './slot.css';
import moment from 'moment';

const Slot = ({ t, label, slots, selected, setSelectedSlot }) => {
  return (
    <div className="calender__slot">
      <p className="slot__info">{label} | {slots.length} {t('SLOTS')}</p>
      <div className="slots__con">
        {
          slots.map((cur) => (
            <button key={cur.id} className={["slots__btn", cur.id === selected && "active"].join(' ')} onClick={() => setSelectedSlot(cur.id, cur.start_time, label)}>{moment(cur.start_time, ["h:mm A"]).format("hh:mm A")}</button>

          ))
        }
      </div>

    </div>
  );
};

export default Slot;